import React from 'react';
import './Navbar.css';
import { NavLink } from "react-router-dom";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import { getLoy3Profile } from 'selectors/authentication';

const SecondaryNavbar = ({loy3Profile}, context) => {
  return (
    <div className="navbar-container">
      <span className="username">{loy3Profile && loy3Profile.firstName}</span>
      <div className="navbar-buttons" style={{ marginBottom: '50px' }}>
        <NavLink
            to="/profile"
            exact
            className="btn"
            activeClassName="active"
        >
            {context.t("My Profile")}
        </NavLink>
        <NavLink
            to="/bookings"
            exact
            className="btn"
            activeClassName="active"
        >
            {context.t("My Bookings")}
        </NavLink>
        <NavLink
            to="/wallet"
            exact
            className="btn"
            activeClassName="active"
        >
            {context.t("Wallet")}
        </NavLink>
        <NavLink
            to="/catalogue"
            exact
            className="btn"
        >
            {context.t("Catalogue")}
        </NavLink>
      </div>
    </div>
  );
};

SecondaryNavbar.propTypes = {
  loy3Profile: PropTypes.object,
};

const mapStateToProps = (state) => ({
  loy3Profile: getLoy3Profile(state),
});

SecondaryNavbar.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  
})

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryNavbar);
